/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './../../core/BaseHttpRequest';
import type { OpenAPIConfig } from './../../core/OpenAPI';
import { AxiosHttpRequest } from './../../core/AxiosHttpRequest';
import { AccountService } from './services/AccountService';
import { AccountExternalService } from './services/AccountExternalService';
import { AccountsService } from './services/AccountsService';
import { ClientApiService } from './services/ClientApiService';
import { CorporateService } from './services/CorporateService';
import { CryptoDepositService } from './services/CryptoDepositService';
import { CryptoPayService } from './services/CryptoPayService';
import { CryptoWithdrawalAddressesService } from './services/CryptoWithdrawalAddressesService';
import { CryptoWithdrawalsService } from './services/CryptoWithdrawalsService';
import { CryptoWithdrawalsV2Service } from './services/CryptoWithdrawalsV2Service';
import { CurrenciesService } from './services/CurrenciesService';
import { DepositService } from './services/DepositService';
import { DevelopmentService } from './services/DevelopmentService';
import { DocumentsService } from './services/DocumentsService';
import { EarnService } from './services/EarnService';
import { FreshChatGatewayService } from './services/FreshChatGatewayService';
import { GiveawaySurveysService } from './services/GiveawaySurveysService';
import { GtmEventsService } from './services/GtmEventsService';
import { LogsService } from './services/LogsService';
import { LoyaltyProgramService } from './services/LoyaltyProgramService';
import { MaintenanceService } from './services/MaintenanceService';
import { PasswordService } from './services/PasswordService';
import { PaymentCardService } from './services/PaymentCardService';
import { PaymentsService } from './services/PaymentsService';
import { ProfileV2Service } from './services/ProfileV2Service';
import { QuestionnaireService } from './services/QuestionnaireService';
import { ReferralService } from './services/ReferralService';
import { ResourcesService } from './services/ResourcesService';
import { SettingsService } from './services/SettingsService';
import { StoriesService } from './services/StoriesService';
import { SupportRequestsService } from './services/SupportRequestsService';
import { UserService } from './services/UserService';
import { UserActivityService } from './services/UserActivityService';
import { WalletService } from './services/WalletService';
import { WalletV2Service } from './services/WalletV2Service';
import { WithdrawalConfigurationService } from './services/WithdrawalConfigurationService';
import { WithdrawalsService } from './services/WithdrawalsService';
import { WithdrawalsV2Service } from './services/WithdrawalsV2Service';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ClientAreaApiClient {
    public readonly account: AccountService;
    public readonly accountExternal: AccountExternalService;
    public readonly accounts: AccountsService;
    public readonly clientApi: ClientApiService;
    public readonly corporate: CorporateService;
    public readonly cryptoDeposit: CryptoDepositService;
    public readonly cryptoPay: CryptoPayService;
    public readonly cryptoWithdrawalAddresses: CryptoWithdrawalAddressesService;
    public readonly cryptoWithdrawals: CryptoWithdrawalsService;
    public readonly cryptoWithdrawalsV2: CryptoWithdrawalsV2Service;
    public readonly currencies: CurrenciesService;
    public readonly deposit: DepositService;
    public readonly development: DevelopmentService;
    public readonly documents: DocumentsService;
    public readonly earn: EarnService;
    public readonly freshChatGateway: FreshChatGatewayService;
    public readonly giveawaySurveys: GiveawaySurveysService;
    public readonly gtmEvents: GtmEventsService;
    public readonly logs: LogsService;
    public readonly loyaltyProgram: LoyaltyProgramService;
    public readonly maintenance: MaintenanceService;
    public readonly password: PasswordService;
    public readonly paymentCard: PaymentCardService;
    public readonly payments: PaymentsService;
    public readonly profileV2: ProfileV2Service;
    public readonly questionnaire: QuestionnaireService;
    public readonly referral: ReferralService;
    public readonly resources: ResourcesService;
    public readonly settings: SettingsService;
    public readonly stories: StoriesService;
    public readonly supportRequests: SupportRequestsService;
    public readonly user: UserService;
    public readonly userActivity: UserActivityService;
    public readonly wallet: WalletService;
    public readonly walletV2: WalletV2Service;
    public readonly withdrawalConfiguration: WithdrawalConfigurationService;
    public readonly withdrawals: WithdrawalsService;
    public readonly withdrawalsV2: WithdrawalsV2Service;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://www.xbo-dev.space-app.io/client-area',
            VERSION: config?.VERSION ?? '2.0.2278.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.account = new AccountService(this.request);
        this.accountExternal = new AccountExternalService(this.request);
        this.accounts = new AccountsService(this.request);
        this.clientApi = new ClientApiService(this.request);
        this.corporate = new CorporateService(this.request);
        this.cryptoDeposit = new CryptoDepositService(this.request);
        this.cryptoPay = new CryptoPayService(this.request);
        this.cryptoWithdrawalAddresses = new CryptoWithdrawalAddressesService(this.request);
        this.cryptoWithdrawals = new CryptoWithdrawalsService(this.request);
        this.cryptoWithdrawalsV2 = new CryptoWithdrawalsV2Service(this.request);
        this.currencies = new CurrenciesService(this.request);
        this.deposit = new DepositService(this.request);
        this.development = new DevelopmentService(this.request);
        this.documents = new DocumentsService(this.request);
        this.earn = new EarnService(this.request);
        this.freshChatGateway = new FreshChatGatewayService(this.request);
        this.giveawaySurveys = new GiveawaySurveysService(this.request);
        this.gtmEvents = new GtmEventsService(this.request);
        this.logs = new LogsService(this.request);
        this.loyaltyProgram = new LoyaltyProgramService(this.request);
        this.maintenance = new MaintenanceService(this.request);
        this.password = new PasswordService(this.request);
        this.paymentCard = new PaymentCardService(this.request);
        this.payments = new PaymentsService(this.request);
        this.profileV2 = new ProfileV2Service(this.request);
        this.questionnaire = new QuestionnaireService(this.request);
        this.referral = new ReferralService(this.request);
        this.resources = new ResourcesService(this.request);
        this.settings = new SettingsService(this.request);
        this.stories = new StoriesService(this.request);
        this.supportRequests = new SupportRequestsService(this.request);
        this.user = new UserService(this.request);
        this.userActivity = new UserActivityService(this.request);
        this.wallet = new WalletService(this.request);
        this.walletV2 = new WalletV2Service(this.request);
        this.withdrawalConfiguration = new WithdrawalConfigurationService(this.request);
        this.withdrawals = new WithdrawalsService(this.request);
        this.withdrawalsV2 = new WithdrawalsV2Service(this.request);
    }
}

